import React from 'react';
import { Route } from 'react-router-dom';
import loadableModule from 'spark-views/main/loadableModule';
import Permission from 'spark-util/Permission';
import { paths } from './downloadRoutes';

const BulkDownload = loadableModule(() => import('./index.js'));

const BulkDownloadRoute = () => (
	<Permission requires="bd.downloadDocuments">
		<Route path={paths.root} component={BulkDownload} />
	</Permission>
);

export default BulkDownloadRoute;
